import {AutoEncoder, field, IntegerDecoder} from '@simonbackx/simple-encoding'

export class EncodeableInteger extends AutoEncoder {
    @field({decoder: IntegerDecoder})
    value: number
}
